<template>
  <!-- 倾听师 -->
  <div class="teacher-wrap">
    <div :class="['fixed-wrap', !!tingStatus ? 'stop-accept' : '']">
      <div :class="['fixed', 'clearfix', !!tingStatus ? 'stop-accept' : '']">
        <div class="fixed-wrap-left" @click="linkToTeacherPage(qingtingInfo)">
          <div class="avatar-wrap">
            <img :src="qingtingInfo.avatar" class="avatar" />
            <span :class="['status-icon', teacherStatus]"></span>
          </div>
          <p class="name">{{ qingtingInfo.nickname }}</p>
        </div>
        <div class="fixed-wrap-right">
          <div class="rate-wrap clearfix">
            <div class="item">
              <p class="label">在线时长</p>
              <p class="txt">{{ qingtingInfo.onlinenum }}分钟</p>
            </div>
            <div class="item">
              <p class="label">好评率</p>
              <p class="txt">{{ qingtingInfo.goodrate }}%</p>
            </div>
          </div>
          <button class="accept-btn disabled" v-if="qingtingInfo.jin == 1">
            暂停服务
          </button>
          <div
            tag="button"
            class="accept-btn"
            v-else-if="tingStatus === 0"
            @click="handleOnline('online')"
          >
            开始接单
          </div>
          <div v-else-if="tingStatus !== 0">
            <div class="clearfix">
              <div
                tag="button"
                :class="[
                  { 'stop-btn': teacherStatus !== 'lock' },
                  'accept-btn'
                ]"
                @click="handleOnline('offline')"
              >
                停止接单
              </div>

              <!-- <div
                tag="span"
                class="error-btn"
                @click="handleErrorStatus"
                v-show="teacherStatus !== 'lock'"
              >
                修正状态
              </div> -->
            </div>
            <span
              :class="[{ 'btn-width': teacherStatus !== 'lock' }, 'countdown']"
            >
              <!-- {{ hour }}时{{ minute }}分{{ second }}秒 -->
              {{ outlineTime | timestampFormater('hh时mm分ss秒') }}
              后下线</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { qingsuToggleStatus } from 'api/qingsu'
import { mapGetters } from 'vuex'
import qingsuCommonMixin from 'mixins/qingsu/common.js'
export default {
  name: 'teacher-fixed-control',
  props: {},
  mixins: [qingsuCommonMixin],
  data() {
    return {
      outlineTime: 0
    }
  },
  filters: {
    timestampFormater(date) {
      var _restTime = date / 1000
      var _hour = Math.floor(_restTime / 3600)
      var _minute = Math.floor((_restTime - _hour * 3600) / 60)
      var _second = Math.floor(_restTime - _hour * 3600 - _minute * 60)
      return `${_hour}时${_minute}分${_second}秒`
    }
  },
  computed: {
    ...mapGetters(['qingtingInfo']),
    tingStatus() {
      if (this.teacherStatus === 'free' && this.qingtingInfo.rest_time <= 0) {
        return 0
      }
      return Number(this.qingtingInfo.ting_status)
    },
    teacherStatus() {
      return this.qingtingInfo.status
    }
  },
  mounted() {
    this.setOutLineClock()
  },
  methods: {
    linkToTeacherPage() {
      // this.$emit('linkToTeacherPage', this.qingtingInfo)
      this.toTeacherDetail(this.qingtingInfo)
    },

    changeStatus(toStatus) {
      clearTimeout(this.outLineClockTimer)
      qingsuToggleStatus({ toStatus })
        .then(res => {
          if (res.code == 0) {
            this.$store.dispatch(`getUserInfo`, true).then(() => {
              this.setOutLineClock()
            })
            this.$success('设置成功')
            // this.$emit('refresh')
          } else {
            this.$fail(res.message)
          }
        })
        .catch(err => {
          this.$fail(`切换失败`)
          console.log(err)
        })
    },

    handleOnline(status) {
      let statName = ``
      switch (status) {
        case 'online':
          statName = '倾诉-首页「开始接单」点击'
          break
        case 'offline':
          statName = '倾诉-首页「停止接单」点击'
          break
      }
      statName && this.$stat.send(statName)
      const title = `是否${status == 'online' ? '开始' : '停止'}接单`
      this.$dialog({
        title,
        buttons: [
          {
            label: '取消'
          },
          {
            label: '确定',
            onClick: () => this.changeStatus(status)
          }
        ]
      })
    },

    handleErrorStatus() {
      this.$stat.send('倾诉-首页「状态有误」点击')

      const title = `若您当前的状态显示有误，可通过选择是否通话中进行更新。请选择：`
      this.$dialog({
        title,
        showClose: true,
        buttons: [
          {
            label: '通话中',
            onClick: () => this.changeStatus('talking')
          },
          {
            label: '非通话中',
            onClick: () => this.changeStatus('online')
          }
        ]
      })
    },
    setOutLineClock() {
      if (this.qingtingInfo.rest_time === 0) {
        return
      }
      this.outLineClockTimer = setInterval(() => {
        if (this.qingtingInfo) {
          const { rest_time, __fetchTime } = this.qingtingInfo
          const oulineTime = __fetchTime + rest_time * 1000
          this.outlineTime = oulineTime - new Date().getTime()
          if (this.outlineTime < 0) {
            clearTimeout(this.outLineClockTimer)
            this.$store.dispatch(`getUserInfo`, true)
          }
        }
      }, 300)
    }
  }
}
</script>

<style lang="scss">
.teacher-wrap {
  width: 100%;
  height: 332px;
  margin: 0 auto;
  background: #fff;
  .clearfix:after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: ' ';
    clear: both;
    height: 0;
  }
  // background-color: #fff;
  .fixed-wrap {
    bottom: 0;
    left: 50%;
    @include fixedPcCenter();
    height: 258px;
    // background-color: #fff;
    &.stop-accept {
      height: 280px;
      bottom: 16px;
    }
    .fixed {
      background-color: #fff;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      box-sizing: border-box;
      width: 718px;
      padding: 20px 0 0;
      height: 242px;
      &.stop-accept {
        height: 280px;
      }
      border: 1px solid #eaeaea;
      border-radius: 20px;
      box-shadow: 0 0 30px #eaeaea;
      .fixed-wrap-left {
        float: left;
        width: 192px;
        box-sizing: border-box;
        padding: 0 36px 0 36px;
        text-align: center;
        .avatar-wrap {
          width: 120px;
          height: 120px;
          margin-bottom: 20px;
          margin-top: 10px;
          position: relative;
          .status-icon {
            position: absolute;
            display: block;
            width: 48px;
            height: 30px;
            right: 0;
            bottom: 0;
            &.free {
              background: url('../../images/qingsu/index/free-status.png')
                no-repeat center;
              background-size: cover;
            }
            &.lock {
              background: url('../../images/qingsu/index/lock-status.png')
                no-repeat center;
              background-size: cover;
            }
            &.jin {
              background: url('../../images/qingsu/index/stop-status.png')
                no-repeat center;
              background-size: cover;
            }
            &.calling {
              background: url('../../images/qingsu/index/on-line-status.png')
                no-repeat center;
              background-size: 100%;
            }
            &.offline {
              background: url('../../images/qingsu/index/off-line-status.png')
                no-repeat center;
              background-size: cover;
            }
          }
          .avatar {
            width: 120px;
            height: 120px;
            border-radius: 50%;
            object-fit: cover;
          }
        }

        .name {
          font-size: 30px;
          color: #333;
          line-height: 1;
        }
      }

      .fixed-wrap-right {
        float: left;
      }

      .rate-wrap {
        .item {
          float: left;
          width: 50%;
          margin-bottom: 18px;
          text-align: center;
          .label {
            font-size: 30px;
            color: #333;
            font-weight: bold;
            margin-bottom: 12px;
          }
          .txt {
            font-size: 28px;
            color: #666;
          }
        }
      }

      .accept-btn {
        border-radius: 10px;
        background-color: #ff745b;
        font-size: 32px;
        color: #fff;
        width: 458px;
        height: 80px;
        display: flex;
        justify-content: center;
        align-items: center;

        &.stop-btn {
          float: left;
          width: 300px;
          /*height: 110);*/
        }
        &.disabled {
          background: #ccc;
        }
      }
      .countdown {
        display: block;
        text-align: center;
        font-size: 24px;
        color: #999;
        line-height: 32px;
        height: 32px;
        margin-top: 16px;
        &.btn-width {
          width: 300px;
        }
      }

      .error-btn {
        float: left;
        display: inline-block;
        line-height: 80px;
        margin-left: 42px;
        font-size: 26px;
        color: #999;
      }
    }
  }
}
</style>
